
const countryIdReducer = (
    state:any = 1,
    action:any
) => {
    const {type, payload} = action
    switch (type) {
        case 'SET_COUNTRY_ID':
            return payload
        default:
            return state 
    }
}

export {countryIdReducer}